/**
 * Una copia de la tienda de verdad, en la computadora de quien la desarrolla (`pnpm copia`).
 *
 * `ops/copia.mjs` brings the shop's log down through a key that can only read, loads it into an
 * API of its own on this computer, and serves this app against it with `VITE_COPIA` set to when
 * the copy was taken. Nothing done in it can reach the shop: the copy's API is a separate server,
 * and the shop only takes events from devices it registered itself. What this module does is the
 * other half, keeping the copy what it says it is:
 *
 * - No demo data and no test till. On a development server a newly enrolled device fills an empty
 *   shop with the demo, or opens a drawer with a test float in a stocked one (`lib/acceso.ts`).
 *   Either would put invented records beside the real ones, and the copy would stop being one.
 * - Said on screen: the tab's title and the status on the home screen. The copy looks exactly
 *   like the shop, and the shop may well be open in the next tab.
 *
 * Unset in every real build, so there this is null and nothing changes.
 */

import { ZONA_HORARIA } from '@abastece/shared';
import { localeActual } from '../i18n/index.js';

/** When the copy was taken (ISO, UTC), or null when this is not a copy. */
export const COPIA_TOMADA: string | null = import.meta.env.VITE_COPIA || null;

export const esCopiaDeTienda = (): boolean => COPIA_TOMADA !== null;

/** «30 sept, 5:40 p. m.»: when, in the shop's own time. */
export const cuandoSeTomo = (iso: string): string =>
  new Date(iso).toLocaleString(localeActual(), {
    day: 'numeric',
    month: 'short',
    hour: 'numeric',
    minute: '2-digit',
    timeZone: ZONA_HORARIA,
  });
